import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { refundPayment } from "api/payments";
import React from "react";
import { toast } from "react-hot-toast";
import { MdHighlightOff, MdOutlineReplayCircleFilled } from "react-icons/md";
import { convertToFloat } from "utils/formatNumber";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { PANEL_STYLES } from "./InfoModal";
 
const RefundModal = ({
  info, fetchPayments, transactionID, varient, enRefund, client_is_deleted,
}: {
  info?: any; fetchPayments: () => void; transactionID: string;
  varient?: string; enRefund?: any; client_is_deleted?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  const handleClose = () => { setIsCloseModal(true); setTimeout(() => { setIsCloseModal(false); onClose(); }, 300); };

  const isDisabled =
    client_is_deleted || info?.client === "Banwire" || info?.et_id?.includes("payout") ||
    ["REFUNDED","ERRORED","DECLINED","CREATED","AUTHORIZED","CANCELLED","PENDING",
     "HELD","DISPUTE","REJECTED","CHARGEBACK","FAILED"].includes(info?.status) || !enRefund;

  async function handleRefund() {
    setIsLoading(true);
    refundPayment({ transaction_id: transactionID }, info.clientId)
      .then((resp: any) => {
        if (resp?.message?.status === "REFUNDED") toast.success("Successfully refunded");
        else if (resp?.message?.status === "REFUND DECLINED") toast.success("Refund declined by gateway");
        else toast.error(!resp.status ? resp?.message : "Refund failed");
        onClose(); fetchPayments();
      })
      .catch((err: any) => toast.error(err?.response?.data?.error ?? "Unable to refund this transaction"))
      .finally(() => setIsLoading(false));
  }

  return (
    <>
      {/* <Popover trigger="hover" placement="bottom"> */}
      
      <span className="inline-flex">
        <button className="txn-action-btn" onClick={onOpen} disabled={isDisabled} aria-label="Refund" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
          <MdOutlineReplayCircleFilled size={14} /> <span>Refund Payment</span>
        </button>
      </span>
        

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`pconfirm-panel${isOpen && !isCloseModal ? " pconfirm-panel--open" : " pconfirm-panel--close"}`}>
          <div className="pconfirm-glow pconfirm-glow--blue" />
          <div className="pconfirm-header pconfirm-header--blue">
            <div className="pconfirm-header-brand">
              <div className="pconfirm-header-logo">
                <MdOutlineReplayCircleFilled size={20} color="#fff" />
              </div>
              <div>
                <h2 className="pconfirm-title">Refund Payment</h2>
                <p className="pconfirm-sub">This will initiate a refund</p>
              </div>
            </div>
            <button className="pconfirm-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="pconfirm-body">
            <div className="pconfirm-info-card">
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Transaction ID</span>
                <span className="pconfirm-info-val">{info?.et_id || "—"}</span>
              </div>
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Refund Amount</span>
                <span className="pconfirm-info-val pconfirm-info-val--amount">
                  {convertToFloat(info?.amount)} {info?.currency}
                </span>
              </div>
            </div>
            <p className="pconfirm-question">
              This will refund the transaction above. The funds will be returned to the original payment method. Do you want to continue?
            </p>
          </div>

          <div className="pconfirm-footer">
            <button className="pconfirm-btn-cancel" onClick={handleClose}>Cancel</button>
            <button
              className="pconfirm-btn-action--blue"
              onClick={handleRefund}
              disabled={!!isLoading || client_is_deleted}
            >
              {isLoading ? (
                <span className="pconfirm-spinner" />
              ) : (
                <><MdOutlineReplayCircleFilled size={14} />Refund</>
              )}
            </button>
          </div>
        </div>
      </Modal>

      {PANEL_STYLES}
    </>
  );
};

export default RefundModal;